import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { SubcategoryTh } from '../BenefitTableRedesign';
import {
  Content,
  withContext,
} from '../../../../components';
import { CONTENT_TYPE_FAST } from '../../../../components/Content';
import { Consumer } from '../../Context';

function SubCategoryMarkupRedesign(props) {
  const {
    context: {
      categoryBenefits,
      editAllowed,
      editSubCategoryName,
      onStartEdit,
      onSaveEdit,
      onCancelEdit,
      width,
      categoryName,
      enableReorder,
    },
  } = props;

  const nameColumnWidth = width === '100%' ? 30 : 50; // Percentage
  const subcategories = [...new Set(categoryBenefits.map(b => b.subcategory))];
  const subcategoryColumnWidth = (100 - nameColumnWidth) / subcategories.length;
  const isNewSubcategory = editSubCategoryName && editSubCategoryName.value === '' && categoryBenefits.some(cb => cb.id === undefined);
  const subCategoryMarkUp = subcategories.map((subcategory, index) => {
    const subCategoryEditMode = editAllowed
    && editSubCategoryName
    && editSubCategoryName.value === subcategory
    && editSubCategoryName.categoryName === categoryName;
    return (
      <Draggable
        key={subcategory}
        draggableId={`subcategory-${subcategory}-${categoryName}`}
        index={index}
        class="subcategory"
        isDragDisabled={!editAllowed || !enableReorder}
      >
        {
      (provided, snapshot) => (
        <SubcategoryTh
          key={subcategory}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          isDragging={snapshot.isDragging}
          scope="col"
          columnWidth={`${subcategoryColumnWidth}%`}
          onClick={subCategoryEditMode === true ? null
            : event => onStartEdit(event, categoryName)}
          value={subcategory}
          name="editSubCategoryName"
          editAvailable={editAllowed && !subCategoryEditMode}
        >
          <Content
            edit={subCategoryEditMode}
            inherit
            onSave={value => onSaveEdit(value, categoryName, isNewSubcategory)}
            onCancel={onCancelEdit}
            type={CONTENT_TYPE_FAST.PLAIN}
            value={subcategory}
          />
        </SubcategoryTh>
      )
    }
      </Draggable>
    );
  });
  return subCategoryMarkUp;
}
export default withContext(Consumer)(SubCategoryMarkupRedesign);
